import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  error: any;
  resetErrorBoundary: any;
}

const ErrorFallback: FC<IProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const { t } = useTranslation();

  console.error('ErrorFallback:', error);
  alert(`${t('common.message.error')}\n${error.message}`);

  const pathname = window.location.pathname;
  if (pathname.includes('/cbt/speaking-test/exam')) {
    window.close();
  }
  
  resetErrorBoundary();

  return null;
}

export default ErrorFallback;